import React from "react"
import styled from "styled-components"
import { graphql, useStaticQuery } from "gatsby"
import Options from "../../constants/projects"
import Item from "./Item"
import { Link } from "gatsby"

const query = graphql`
  {
    allFile(
      filter: { relativeDirectory: { eq: "design-projects" } }
      sort: { fields: name }
    ) {
      nodes {
        relativeDirectory
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  }
`

const WhatWeCanList = () => {
  const data = useStaticQuery(query)
  const {
    allFile: { nodes: images },
  } = data
  return (
    <Wrapper>      
        {Options.map((item, index) => {
            return <Item key={index} item={item} image={images[index]} />
        })}  

        <Link to="#" className="btn btn-bordered">
            View Our Portfolio
        </Link>
    </Wrapper>
  )
}

const Wrapper = styled.section`
.btn {
  display: none;
}
@media screen and (min-width: 1025px) {
    padding: 0;
    width: 90vw;
    margin: 100px auto;
    max-width: 1170px;
    .btn {
      display: inherit;
      padding: 20px;
      text-align: center;
      margin: 0 auto;
      width: 238px;
    }
}
@media (min-width: 1180px) {width: 100%;}
`
export default WhatWeCanList
